import { TkaTypography } from "./typography";

export abstract class TypographyFactory {
	constructor(protected readonly typography: TkaTypography) {}

	create(): any {}
}
